<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="Icon / Arrow---left">
<path id="Union" d="M11.4697 21.0156C11.7626 21.3085 12.2374 21.3085 12.5303 21.0156C12.8232 20.7227 12.8232 20.2478 12.5303 19.9549L5.32538 12.75L20.4853 12.75C20.8995 12.75 21.2353 12.4142 21.2353 12C21.2353 11.5857 20.8995 11.25 20.4853 11.25L5.32538 11.25L12.5303 4.04501C12.8232 3.75211 12.8232 3.27724 12.5303 2.98435C12.2374 2.69145 11.7626 2.69145 11.4697 2.98435L2.45406 12L11.4697 21.0156Z" fill="currentColor"/>
</g>
</svg>
